import { SynchronizedObject32xqzf15iiskd as SynchronizedObject } from '../../internal/Synchronized.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { copyOf2ng0t8oizk6it as copyOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  Companion_instance1xjg859pd52fi as Companion_instance,
  _Result___init__impl__xyqfz823vatsdepqb9n as _Result___init__impl__xyqfz8,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { SharedFlowImplm7e4zqeuk15m as SharedFlowImpl } from '../SharedFlow.mjs';
import { BufferOverflow_DROP_OLDEST_getInstance3u1027cpcc1wz as BufferOverflow_DROP_OLDEST_getInstance } from '../../channels/BufferOverflow.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function get_EMPTY_RESUMES() {
  _init_properties_AbstractSharedFlow_kt__h2xygb();
  return EMPTY_RESUMES;
}
var EMPTY_RESUMES;
var AbstractSharedFlowClass;
function AbstractSharedFlow() {
  if (AbstractSharedFlowClass === VOID) {
    class $ extends SynchronizedObject() {
      constructor() {
        super();
        this.k1e_1 = null;
        this.l1e_1 = 0;
        this.m1e_1 = 0;
        this.n1e_1 = null;
      }
      g1f() {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        var tmp0_elvis_lhs = this.n1e_1;
        var tmp;
        if (tmp0_elvis_lhs == null) {
          // Inline function 'kotlin.also' call
          var this_0 = new (SubscriptionCountStateFlow())(this.l1e_1);
          this.n1e_1 = this_0;
          tmp = this_0;
        } else {
          tmp = tmp0_elvis_lhs;
        }
        return tmp;
      }
      x1e() {
        var subscriptionCount;
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        var curSlots = this.k1e_1;
        var tmp;
        if (curSlots == null) {
          // Inline function 'kotlin.also' call
          var this_0 = this.f1f(2);
          this.k1e_1 = this_0;
          tmp = this_0;
        } else {
          var tmp_0;
          if (this.l1e_1 >= curSlots.length) {
            // Inline function 'kotlin.also' call
            var this_1 = copyOf(curSlots, imul(2, curSlots.length));
            this.k1e_1 = this_1;
            tmp_0 = this_1;
          } else {
            tmp_0 = curSlots;
          }
          tmp = tmp_0;
        }
        var slots = tmp;
        var index = this.m1e_1;
        var slot;
        $l$loop: while (true) {
          var tmp0_elvis_lhs = slots[index];
          var tmp_1;
          if (tmp0_elvis_lhs == null) {
            // Inline function 'kotlin.also' call
            var this_2 = this.e1f();
            slots[index] = this_2;
            tmp_1 = this_2;
          } else {
            tmp_1 = tmp0_elvis_lhs;
          }
          slot = tmp_1;
          index = index + 1 | 0;
          if (index >= slots.length)
            index = 0;
          if ((slot instanceof AbstractSharedFlowSlot() ? slot : THROW_CCE()).i1f(this))
            break $l$loop;
        }
        this.m1e_1 = index;
        this.l1e_1 = this.l1e_1 + 1 | 0;
        subscriptionCount = this.n1e_1;
        var slot_0 = slot;
        if (subscriptionCount == null)
          null;
        else
          subscriptionCount.x1f(1);
        return slot_0;
      }
      b1f(slot) {
        var subscriptionCount;
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        this.l1e_1 = this.l1e_1 - 1 | 0;
        subscriptionCount = this.n1e_1;
        if (this.l1e_1 === 0)
          this.m1e_1 = 0;
        var resumes = (slot instanceof AbstractSharedFlowSlot() ? slot : THROW_CCE()).k1f(this);
        var inductionVariable = 0;
        var last = resumes.length;
        while (inductionVariable < last) {
          var cont = resumes[inductionVariable];
          inductionVariable = inductionVariable + 1 | 0;
          if (cont == null)
            null;
          else {
            // Inline function 'kotlin.coroutines.resume' call
            // Inline function 'kotlin.Companion.success' call
            var tmp$ret$4 = _Result___init__impl__xyqfz8(Unit_instance);
            cont.oc(tmp$ret$4);
          }
        }
        if (subscriptionCount == null)
          null;
        else
          subscriptionCount.x1f(-1);
      }
    }
    initMetadataForClass($, 'AbstractSharedFlow');
    AbstractSharedFlowClass = $;
  }
  return AbstractSharedFlowClass;
}
var AbstractSharedFlowSlotClass;
function AbstractSharedFlowSlot() {
  if (AbstractSharedFlowSlotClass === VOID) {
    class $ {}
    initMetadataForClass($, 'AbstractSharedFlowSlot');
    AbstractSharedFlowSlotClass = $;
  }
  return AbstractSharedFlowSlotClass;
}
var SubscriptionCountStateFlowClass;
function SubscriptionCountStateFlow() {
  if (SubscriptionCountStateFlowClass === VOID) {
    class $ extends SharedFlowImpl() {
      constructor(initialValue) {
        super(1, 2147483647, BufferOverflow_DROP_OLDEST_getInstance());
        this.c1f(initialValue);
      }
      n3() {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        return this.v1e();
      }
      x1f(delta) {
        // Inline function 'kotlinx.coroutines.internal.synchronized' call
        // Inline function 'kotlinx.coroutines.internal.synchronizedImpl' call
        return this.c1f(this.v1e() + delta | 0);
      }
    }
    initMetadataForClass($, 'SubscriptionCountStateFlow', VOID, VOID, VOID, [1]);
    SubscriptionCountStateFlowClass = $;
  }
  return SubscriptionCountStateFlowClass;
}
var properties_initialized_AbstractSharedFlow_kt_2mpafr;
function _init_properties_AbstractSharedFlow_kt__h2xygb() {
  if (!properties_initialized_AbstractSharedFlow_kt_2mpafr) {
    properties_initialized_AbstractSharedFlow_kt_2mpafr = true;
    // Inline function 'kotlin.arrayOfNulls' call
    EMPTY_RESUMES = Array(0);
  }
}
//region block: exports
export {
  AbstractSharedFlowSlot as AbstractSharedFlowSlot2hcw2f06t03o0,
  AbstractSharedFlow as AbstractSharedFlow1jjql04jld86z,
  get_EMPTY_RESUMES as get_EMPTY_RESUMES1se3895plb5u1,
};
//endregion

//# sourceMappingURL=AbstractSharedFlow.mjs.map
